import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target, Zap, PlayCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Fundamentos de la Hidrología', '✅ TOMO 2: Aguas Superficiales y Cuencas', '✅ TOMO 3: Aguas Subterráneas y Acuíferos', '✅ TOMO 4: Hidrometeorología y Fenómenos Extremos', '✅ TOMO 5: Calidad del Agua y Contaminación', '✅ TOMO 6: Hidrología Aplicada y Proyectos', '🎁 BONO 1: 100 Actividades para el Aula', '🎁 BONO 2: Banco de Evaluaciones y Exámenes', '🎁 BONO 3: Atlas Hidrológico Argentino', '🎁 BONO 4: Planificaciones Docentes', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const maestroFeatures = ['✅ TOMO 1: Fundamentos de la Hidrología', '✅ TOMO 2: Aguas Superficiales y Cuencas', '✅ TOMO 3: Aguas Subterráneas y Acuíferos', '✅ TOMO 4: Hidrometeorología y Fenómenos Extremos', '✅ TOMO 5: Calidad del Agua y Contaminación', '✅ TOMO 6: Hidrología Aplicada y Proyectos', '🎁 BONO 1: 100 Actividades para el Aula', '🎁 BONO 2: Banco de Evaluaciones y Exámenes', '🎁 BONO 3: Atlas Hidrológico Argentino', '🎁 BONO 4: Planificaciones Docentes', '🔬 NIVEL AVANZADO: Hidrología Avanzada y Gestión de Recursos Hídricos', '📐 NIVEL AVANZADO: Megapack Proyectos y Ferias de Ciencias sobre el Agua', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Enseñar en 5to o 6to año con mayor profundidad',
    sin: 'Usás el mismo material de siempre',
    con: 'Hidrología cuantitativa, hidrogeología, gestión integrada y derecho del agua'
  }, {
    sit: 'Preparar proyectos para la Feria de Ciencias',
    sin: 'Improvisás sin guía',
    con: '40 proyectos completos con metodología, cronograma y rúbrica'
  }, {
    sit: 'Articular con otros docentes',
    sin: 'Sin sistema',
    con: 'Planificaciones interdisciplinarias y secuencias colaborativas'
  }, {
    sit: 'Llevar los proyectos más allá del aula',
    sin: 'El proyecto termina en el cuaderno',
    con: 'Guía de impacto comunitario con Observatorios Hídricos Escolares'
  }, {
    sit: 'Preparar alumnos para la FENCYT',
    sin: 'Sin herramientas',
    con: 'Guía completa para ferias de ciencias nacionales'
  }, {
    sit: 'Trabajar con nivel terciario o universitario',
    sin: 'Sin contenido avanzado',
    con: 'Ley de Darcy, índices de sequía, análisis de series temporales'
  }];
  return <section id="pricing" className="py-24 bg-[#0f1d35]" data-id="element-201">
      <div className="container mx-auto px-4" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-204">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-slate-300 text-[16px]" data-id="element-205">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-206">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0a1428] rounded-3xl p-8 shadow-2xl border border-slate-500/30 flex flex-col h-full relative z-10" data-id="element-207">
            <div className="mb-6" data-id="element-208">
              <p className="text-slate-400 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-209">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-210">
                💧 MEGAPACK HIDROLOGÍA LISTO™
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-211">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-500/30" data-id="element-212"></div>

            <div className="mb-8" data-id="element-213">
              <div className="flex items-end gap-2" data-id="element-214">
                <span className="text-5xl font-black text-white" data-id="element-215">$19.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-216">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-217">$45.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-218">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-219">
                  <span className="text-slate-300 text-[15px]" data-id="element-220">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53828771578174:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-221">
              <Button variant="outline" size="lg" fullWidth data-id="element-222">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#0a1428] rounded-3xl p-8 shadow-2xl border-2 border-slate-300 flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-223">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-950 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-224">
              <Zap className="w-4 h-4 fill-slate-950" data-id="element-225" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-226">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-227">
                💧 MEGAPACK HIDROLOGÍA LISTO™ + NIVEL AVANZADO
              </h3>
              <p className="text-slate-300 font-bold" data-id="element-228">
                Todo lo anterior + Hidrología Avanzada + Proyectos y Ferias
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-500/30" data-id="element-229"></div>

            <div className="mb-8" data-id="element-230">
              <div className="flex items-end gap-2" data-id="element-231">
                <span className="text-5xl font-black text-white" data-id="element-232">$27.990</span>
                <span className="text-xl font-bold text-slate-300 mb-1" data-id="element-233">
                  ARS
                </span>
              </div>
              <p className="text-slate-500 line-through mt-1" data-id="element-234">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-235">
              {maestroFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                  <Zap className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-237" />
                  <span className={i >= 10 && i <= 11 ? 'text-slate-200 font-bold' : 'text-slate-300'} data-id="element-238">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53828772331838:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-239">
              <Button variant="premium" size="lg" fullWidth data-id="element-240">
                ⚡ QUIERO EL MEGAPACK + NIVEL AVANZADO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-slate-400 text-sm mb-20" data-id="element-241">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell Details */}
        <div className="max-w-4xl mx-auto" data-id="element-242">
          <div className="text-center mb-10" data-id="element-243">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white flex items-center justify-center gap-2" data-id="element-244">
              <Target className="w-8 h-8 text-slate-300" data-id="element-245" />
              🎯 ¿QUÉ AGREGA EL NIVEL AVANZADO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-246">
            <div className="min-w-[700px]" data-id="element-247">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-248">
                <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-249">
                  Situación
                </div>
                <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-250">
                  ❌ Sin Nivel Avanzado
                </div>
                <div className="font-bold text-slate-300 uppercase text-sm tracking-wider" data-id="element-251">
                  ✅ Con Nivel Avanzado
                </div>
              </div>

              <div className="space-y-2" data-id="element-252">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-[#0a1428]/60 rounded-xl p-4 items-center border border-slate-500/30" data-id="element-253">
                    <div className="text-slate-300 font-medium text-sm" data-id="element-254">
                      {row.sit}
                    </div>
                    <div className="text-red-300/80 text-sm" data-id="element-255">{row.sin}</div>
                    <div className="text-slate-200 font-medium text-sm" data-id="element-256">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#0f1d35] to-[#1e3a5f] rounded-2xl p-6 md:p-8 border border-slate-400/30 shadow-xl" data-id="element-257">
            <h4 className="font-bold text-slate-200 mb-6 uppercase tracking-wider" data-id="element-258">
              🔬 NIVEL AVANZADO — ¿QUÉ INCLUYE?
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-259">
              <div className="space-y-6" data-id="element-260">
                <h5 className="font-bold text-slate-300 border-b border-slate-500/50 pb-2" data-id="element-261">
                  🔬 Hidrología Avanzada y Gestión de Recursos Hídricos
                </h5>
                <div data-id="element-262">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-263">
                    <span className="text-slate-300" data-id="element-264">📊</span> HIDROLOGÍA
                    CUANTITATIVA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-265">
                    Balance hídrico con ecuaciones, morfometría de cuencas,
                    hidrogramas de crecida, análisis de frecuencia de eventos
                    extremos y Curva Número. Para 5to y 6to año y formación
                    docente.
                  </p>
                </div>
                <div data-id="element-266">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-267">
                    <span className="text-slate-300" data-id="element-268">🌍</span> HIDROGEOLOGÍA
                    AVANZADA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-269">
                    Ley de Darcy, transmisividad, vulnerabilidad de acuíferos
                    (método DRASTIC), calidad química del agua subterránea y
                    diagramas de Piper.
                  </p>
                </div>
                <div data-id="element-270">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-271">
                    <span className="text-slate-300" data-id="element-272">🌪️</span> HIDROMETEOROLOGÍA
                    APLICADA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-273">
                    Índices de sequía (SPI, NDVI), análisis de series
                    temporales, sistemas de alerta temprana y boletines
                    hidrológicos del INA.
                  </p>
                </div>
                <div data-id="element-274">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-275">
                    <span className="text-slate-300" data-id="element-276">⚖️</span> DERECHO DEL AGUA
                    Y GEOPOLÍTICA HÍDRICA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-277">
                    El agua como derecho humano, marco jurídico argentino,
                    tratados internacionales, análisis de casos (Riachuelo,
                    Botnia, Río Atuel).
                  </p>
                </div>
              </div>

              <div className="space-y-6" data-id="element-278">
                <h5 className="font-bold text-slate-300 border-b border-slate-500/50 pb-2" data-id="element-279">
                  📐 Megapack Proyectos y Ferias de Ciencias sobre el Agua
                </h5>
                <div data-id="element-280">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-281">
                    <span className="text-slate-300" data-id="element-282">🔬</span> GUÍA METODOLÓGICA
                    COMPLETA
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-283">
                    Método científico aplicado al aula, diseño experimental paso
                    a paso, análisis de datos, conclusiones y formatos de
                    comunicación.
                  </p>
                </div>
                <div data-id="element-284">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-285">
                    <span className="text-slate-300" data-id="element-286">🏫</span> 40 PROYECTOS
                    COMPLETOS
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-287">
                    20 proyectos para primaria y 20 para secundaria. Cada uno
                    con ficha completa, procedimiento detallado, tablas de
                    datos, preguntas de análisis y rúbrica de evaluación.
                  </p>
                </div>
                <div data-id="element-288">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-289">
                    <span className="text-slate-300" data-id="element-290">🏆</span> GUÍA PARA FERIAS
                    DE CIENCIAS
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-291">
                    Cómo diseñar el panel, qué evalúan los jurados, cómo
                    preparar la defensa oral y qué preguntas hacen en la FENCYT.
                  </p>
                </div>
                <div data-id="element-292">
                  <p className="font-bold text-white flex items-center gap-2 mb-1" data-id="element-293">
                    <span className="text-slate-300" data-id="element-294">🌱</span> PROYECTOS DE
                    IMPACTO COMUNITARIO
                  </p>
                  <p className="text-slate-300 text-sm" data-id="element-295">
                    Observatorio Hídrico Escolar, Programa Guardianes del Agua,
                    Escuelas Sin Sed. Proyectos que trascienden el aula y
                    generan cambios reales.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}